export default __webpack_public_path__ + "005d14e5c678aad175ff01d2ba075554.png";